import { z } from 'zod';

export const GitHubCoverageReasonSchema = z.enum([
  'no-app',
  'app-target-not-visible',
  'connected-user-only',
  'no-scan',
]);
export type GitHubCoverageReason = z.infer<typeof GitHubCoverageReasonSchema>;

/** Shared truthfulness contract for App- and PAT-backed GitHub reads. */
export const GitHubCoverageSchema = z.object({
  source: z.enum(['app', 'pat']),
  completeness: z.enum(['full', 'partial']),
  reasons: z.array(GitHubCoverageReasonSchema),
});
export type GitHubCoverage = z.infer<typeof GitHubCoverageSchema>;

export const PERSONAL_GITHUB_COVERAGE: GitHubCoverage = {
  source: 'pat',
  completeness: 'partial',
  reasons: ['connected-user-only', 'no-scan'],
};
